let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7b7XW")).then(() => parcelRequire('8Ib5W'));